import { useLandingPage } from '#src/app/pages/search/shared/hooks';
import { SuggestedPetitionsLazy } from '#src/app/shared/components/suggestedPetitionsLazy';

export const PromotedPetitions: React.FC = () => {
	const {
		data: { showLandingPage },
	} = useLandingPage();

	if (!showLandingPage) return null;

	return (
		<div className="mt-16">
			<SuggestedPetitionsLazy
				channel="search_index"
				sourceLocation="search_footer"
				headingClassName="text-typography-strong mt-0 mb-6 pb-0"
				headingSize="small"
				headingType="h2"
			/>
		</div>
	);
};
